// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__ig4jn","main":"index_main__0lthI","collapseContent":"index_collapseContent__Vgvv4"};